














import Vue from 'vue'
import Component from 'vue-class-component'
import { AppModule } from '@app/componentlib/src/store/modules/app'

@Component<ReadMore>({
  props: {
    content: String
  },
  watch: {
    content() {
      if(this.content != undefined) {
        this.isCollapsed = true
        this.displayedContent = this.content.slice(0, this.charactersToShow).concat("", "...")
      }
    }
  }
})

export default class ReadMore extends Vue {
  /**
   * Props variables
   */
  content: string | undefined


  /**
   * Component state variables
   */
  displayedContent = ""
  isCollapsed = false
  charactersToShow = this.isMobile ? 50 : 100


  /**
   * Lifecycle
   */
  mounted() {
    this.toggleContent(this.charactersToShow)
  }

  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get isMobile (): boolean {
    return AppModule.isMobile
  }


  /**
   * Methods
   */
  toggleContent(shortenSize = 100) {
    if (this.content != undefined) {
      if (this.isCollapsed === false) {
        // Shorten the text and put "..." at the end of the string
        this.displayedContent = this.content.slice(0, shortenSize).concat("", "...");
        this.isCollapsed = !this.isCollapsed;
      } else {
        this.displayedContent = this.content;
        this.isCollapsed = !this.isCollapsed;
      }
    }
  }
}
